<template>

    <div id="loginBox" style="display: block">

    <div class="loginbac">
      <div class="loginBox_tel commonBox">
        <div class="telbox commonBox_c">

          <div class="fromlogin">
            <div id="loding_tencenthuakuai" style="display: none">
              加载中. . .
            </div>
            <p class="tittle">绑定手机号</p>
            <div class="inputbox">
              <input type="text" v-model="form.mobile" name="mobile" placeholder="请输入手机号" />
            </div>
            <div class="inputbox border_b">
              <input v-model="form.code"
                type="text"
                name="codeTel"
                placeholder="请输入短信验证码"
              />
              <span class="codetext" data-type="login" @click="getSmsCode">{{djs > 0 ? `${djs}秒后获取` : "获取验证码"}}</span>
            </div>
            <button class="login_tel" @click="mobileBinding">绑定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api/api"
import global from "@/global.vue";
export default {
  data() {
    return {
      active:false,
      titleinformarion:"",
      informarion:"",
      opacity: false,
		  displays:"quick",
      footermobile: "",
      footername: "",
      aName: "",
	    logininput:false,
      //导航背景图，首页不展示
      navhimg: require("@/assets/images/header_bj.jpg"),
      djs: 0,
      form: {
          mobile: "",
          code: "",
          s_id: ""
      },
      user: {},
        store:null
    };
  },
  methods:{
    getSmsCode() {
        if (this.form.mobile && this.djs <= 0) {
            Api.Login.sendSmsCode(this.form.mobile, "changemobile").then(res => {
                this.djs = 60;
                this.form.s_id = res.s_id;
                let t = setInterval(() => {
                    this.djs-- > 0 || clearInterval(t)
                }, 1000)
            });
        }
    },
    mobileBinding(){
        let form = this.form;
        if (!form.s_id) {
            this.prompts("请先获取验证码","请先获取验证码")
            return;
        }
        if (form.mobile && form.code) {
            Api.User.mobileBind(form.mobile, form.code, form.s_id).then(res => {
                this.$emit("bindSucc")
            })
        }
    }
  }
}
</script>
<style scoped>
.box{
  /* background:url(../../assets/images/banner.jpg)no-repeat center; */
}
.navigation_h {
  width: 100%;
  height: 118px;
  background-size: cover !important;
}
.navigation {
  height: 118px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.navigation_dx {
  border-bottom: solid 1px #c9d9e8;
}
.nav_m {
  min-width: 1200px;
  height: 100%;
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.logo {
  margin-top: 18px;
  height: 80px;
}
.logo img {
  height: 100%;
}
.navs {
  display: inline-block;
  margin-top: 42px;
  margin-right: 93px;
}
.navs ul li {
  display: inline-block;
  margin-left: 12px;
  position: relative;
}
.navs ul li .bka {
  border-radius: 25px;
  -o-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -ms-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.navs ul li .bkb {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: rgba(255, 157, 102, 1);
  border-radius: 5px;
  overflow: hidden;
}
.navs ul li .bkb.show {
  display: block;
}
.navs ul li .nava {
  color: #ffffff;
  font-size: 20px;
  padding: 6px 20px;
  border-radius: 25px;
  line-height: 24px;
  display: block;
}
.navs ul li .bkb dd {
  width: 100%;
  text-align: center;
  font-size: 14px;
  padding: 5px 0;
  color: #ffffff;
  overflow: hidden;
}
.navs ul li .bkb dd .navab {
  color: #ffffff;
}
.navs ul li .bkb dd:hover {
  background: #f64e1a;
}

.navs ul li:hover .bka {
  background: #ff9d66;
}
.navs ul li .bka.active {
  background: #ff9d66;
}
.IndividualUsers {
  color: white;
  position: relative;
    /*right: -150px;*/
}
/* #loginBox,
.statusPop,
.statusPop1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 100;
  display: none;
} */
#loginBox .loginbac {
  width: 380px;
  position: absolute;
  left: 50%;
  margin-left: -190px;
  top: 150px;
}
#loginBox .loginbac .commonBox {
  width: 380px;
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid;
  box-sizing: content-box;
}
#loginBox .loginbac .commonBox .commonBox_c {
  padding: 30px;
}
#loginBox .loginbac .commonBox .commonBox_c .close {
  color: 666;
  font-size: 18px;
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
#loginBox .loginbac .commonBox .commonBox_c .tittle {
  font-size: 20px;
  color: #000000;
  font-weight: bold;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin {
  width: 100%;
  padding: 20px 0 0 0;
  position: relative;
}
#loding_tencenthuakuai {
  width: 100%;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 10;
  color: white;
  overflow: hidden;
  text-align: center;
  line-height: 100px;
  transition: 1s;
  border: solid 1px #cbcbcb;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox {
  position: relative;
  width: 100%;
  height: 50px;
  border: solid 1px #cbcbcb;
  border-bottom: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox input {
  width: 317px;
  height: 48px;
  text-indent: 10px;
  margin-left: 1px;
  border: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox .codetext {
  display: inline-block;
  position: absolute;
  top: 13px;
  right: 15px;
  font-size: 14px;
  color: #333333;
  cursor: pointer;
  padding-left: 25px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember label {
    cursor: pointer;
    font-size: 14px;
    color: #666666;
    position: relative;
    padding-left: 15px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember input {
    display: none;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember span {
    display: inline-block;
    width: 12px;
    height: 12px;
    background: url(../../assets/images/gou1.png)no-repeat center;
    background-size: 12px;
    position: absolute;
    left: 0;
    top: 1px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember input:checked + span {
    background: url(../../assets/images/gou.png)no-repeat center;
    background-size: 12px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .changeUser {
    cursor: pointer;
    font-size: 14px;
    color: #30a15d;
    margin-top: 15px;
}
.login_way .way {
    text-align: right;
    cursor: pointer;
    font-size: 14px;
    margin-top: 15px;
}
.login_way p {
    width: 50%;
    float: left;
    cursor: pointer;
    color: #30a15d;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .inputbox.border_b {
  border-bottom: solid 1px #cbcbcb;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember {
  margin-top: 15px;
  position: relative;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .login_tel {
  cursor: pointer;
  width: 100%;
  height: 50px;
  background-color: #30a15d;
  border-radius: 4px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 20px;
  border: 0;
}
.login_way {
  width: 100%;
  height: 40px;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .xieyi {
  font-size: 12px;
  color: #999999;
  margin-top: 14px;
}
dl, dd, p {
    margin-bottom: 0;
}
#loginBox .loginbac .commonBox .commonBox_c .fromlogin .remember .forget {
    position: absolute;
    right: 0;
    cursor: pointer;
    color: #30a15d;
    display: inline-block;
}
#loginBox .loginbac .commonBox .commonBox_c .tittle .register {
    float: right;
    font-size: 14px;
    color: #30a15d;
    margin-top: 5px;
    font-weight: 500;
    cursor: pointer;
}
#loginBox .loginbac .commonBox .commonBox_c .ms {
    font-size: 14px;
    color: #999;
    margin-top: 14px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles {
    margin-top: 15px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles input:checked + span {
    background: url(../../assets/images/checked4.png)no-repeat center;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles span {
    display: inline-block;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 0;
    top: 1px;
    background: url(../../assets/images/checked3.png)no-repeat center;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles label {
    cursor: pointer;
    font-size: 14px;
    color: #333333;
    position: relative;
    padding-left: 19px;
    margin-right: 10px;
}
#loginBox .loginbac .commonBox .commonBox_c .switchRoles input {
    display: none;
}
.eqrcode_div_active {
    top: 0 !important;
    opacity: 1 !important;
}
.eqrcode_div {
    width: 100%;
    height: 100%;
    top: -100%;
    opacity: 0;
    left: 0;
    background: rgba(0,0,0,0.7);
    position: fixed;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
}
.tittle {
    font-size: 20px;
    color: #000000;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
}
</style>
